import { Link } from 'react-router-dom';
import './OnboardingBanner.scss';

const STEPS = [
    { num: 1, text: 'Скопируйте URL подписки из карточки подписки' },
    { num: 2, text: 'Настройте VPN на устройстве — инструкция в разделе «Помощь»' },
];

export default function OnboardingBanner() {
    return (
        <div className="onboarding-banner">
            <div className="onboarding-banner__header">
                <h3 className="onboarding-banner__title">Как начать</h3>
            </div>
            <ol className="onboarding-banner__steps">
                {STEPS.map((step) => (
                    <li key={step.num}>
                        <span className="onboarding-banner__num">{step.num}</span>
                        {step.text}
                    </li>
                ))}
            </ol>
            <div className="onboarding-banner__links">
                <Link to="/help" className="btn btn--outline btn--sm">Помощь</Link>
            </div>
        </div>
    );
}
